export const LIST_TYPE_MOTORCYCLE = "LIST_TYPE_MOTORCYCLE"
export const LIST_BRAND_MOTORCYCLE = "LIST_BRAND_MOTORCYCLE"
export const LIST_FEATURED_MOTO = "LIST_FEATURED_MOTO"
export const DETAIL_MOTORCYCLE = "DETAIL_MOTORCYCLE"
export const LOADING_MOTORCYCLE = "LOADING_MOTORCYCLE"

export const LOADING_HOME_MOTORCYCLE = "LOADING_HOME_MOTORCYCLE"
export const LOADING_FEATURED_MOTORCYCLE = "LOADING_FEATURED_MOTORCYCLE"